<div class="search-container container-lg py-2">
  <form class="search-form" [formGroup]="group" (ngSubmit)="performSearch()" xFormErrorBoundary>
    <mat-form-field>
      <mat-label i18n="@@Note.WatAreYouLookingFor">What are you looking for</mat-label>
      <input
        #searchInput
        type="search"
        matInput
        [matAutocomplete]="autoGroup"
        i18n-placeholder="@@FormInput.SearchProducts.Placeholder"
        placeholder="Search products..."
        formControlName="search"
        [cdkTrapFocus]="searchFocus"
        [cdkTrapFocusAutoCapture]="searchFocus"
        autocomplete="off"
      />

      <mat-autocomplete #autoGroup="matAutocomplete" (optionSelected)="performSearch()">
        <mat-option *ngFor="let option of recentSearches$ | async" [value]="option.searchText">
          <div class="d-flex align-items-center gap-2">
            <div class="icon-spacer">
              <fa-icon icon="clock"></fa-icon>
            </div>
            {{ option.searchText }}
          </div>
        </mat-option>
        <mat-option *ngFor="let option of searchAutoComplete$ | async" [value]="option">
          <div class="d-flex align-items-center gap-2">
            <div class="icon-spacer"></div>
            {{ option }}
          </div>
        </mat-option>
      </mat-autocomplete>

      <x-input-loader matSuffix *ngIf="searching$ | async"></x-input-loader>

      <fa-icon
        *ngIf="showClearButton$ | async"
        class="clear-input"
        (click)="clearSearch($event)"
        icon="times"
        xIconSize="x-small"
      ></fa-icon>

      <button
        matSuffix
        class="search-button"
        mat-flat-button
        type="submit"
        aria-label="search"
        color="primary"
        [disabled]="searchControl.invalid"
      >
        <fa-icon
          [matTooltip]="searchControl.invalid ? 'Enter text to search' : 'Search'"
          icon="search"
        ></fa-icon>
      </button>

      <mat-error xFormError="search"></mat-error>
    </mat-form-field>
  </form>
</div>
